module.exports = __webpack_public_path__ + "images/header-bg-ef6f532ece5691a10408e74ccd0d34fa.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/header-bg.jpg
 ** module id = 380
 ** module chunks = 0
 **/